// firebase.js
// import { firebaseConfig } from '@features/messages/firebase/firebase.config';
import { initializeApp } from '@firebase/app';
import { getMessaging, getToken, onMessage } from '@firebase/messaging';

const firebaseConfig = {
	apiKey: "AIzaSyAkvwymuZznkqtLBuOsBKeTQ3-nxw3kpHo",
	authDomain: "f55glob.firebaseapp.com",
	projectId: "f55glob",
	storageBucket: "f55glob.firebasestorage.app",
	messagingSenderId: "256005027918",
	appId: "1:256005027918:web:b288de35ec060b984bab1f"
};
const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);
const setupNotifications = async () => {
	try {
		// Request permission for notifications
		const permission = await Notification.requestPermission();

		if (permission === 'granted') {
			console.log('Notification permission granted.');
			// Get the FCM token
			const token = await getToken(messaging);
			console.log('FCM Token:', token);
		} else {
			console.log('Notification permission denied.');
		}
		// Handle foreground notifications
		onMessage(messaging, (payload) => {
			console.log('Foreground Message:', payload);
			// Handle the notification or update your UI
		});
	} catch (error) {
		console.error('Error setting up notifications:', error);
	}
};
export { messaging, setupNotifications };
